import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

// MGBW: Surya buttons have no hover effect. Pin each button's hover/active/focus
// state to its rest colors so MGBW matches Surya. Render-time brand check
// (SSR-safe); no-op for Surya / Global Views.
const mgbwSavedOrderOutlineButtonTextColor = "#545454";

const mgbwOutlineButtonNoHover = css`
    ${() =>
        isMgbwWebsite()
            ? css`
                  color: ${mgbwSavedOrderOutlineButtonTextColor} !important;
                  span[class^="TypographyStyle"] {
                      color: ${mgbwSavedOrderOutlineButtonTextColor} !important;
                  }

                  &:not(:disabled):hover,
                  &:active,
                  &:focus {
                      color: ${mgbwSavedOrderOutlineButtonTextColor} !important;
                      border-color: ${COLORS.black} !important;
                      background: transparent !important;
                      span[class^="TypographyStyle"] {
                          color: ${mgbwSavedOrderOutlineButtonTextColor} !important;
                      }
                  }
              `
            : null}
`;

const mgbwSolidButtonNoHover = css`
    ${() =>
        isMgbwWebsite()
            ? css`
                  &:not(:disabled):hover,
                  &:active,
                  &:focus {
                      background: ${COLORS.darkmagenta} !important;
                      border-color: ${COLORS.black} !important;
                      color: ${COLORS.white} !important;
                      box-shadow: none !important;
                      span[class^="TypographyStyle"] {
                          color: ${COLORS.white} !important;
                      }
                  }
              `
            : null}
`;

savedOrderDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
    css: css`
        ${mgbwOutlineButtonNoHover}
    `,
};
savedOrderDetailsActionButtonsStyles.deleteButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        border:1px solid ${COLORS.black} !important;
        ${mgbwOutlineButtonNoHover}
        /* border-radius: 0px;
        padding: 10px 34px;
        background: ${COLORS.background.main};
        border: 2px solid ${COLORS.primary.base} !important; */
        /* &:hover {
            background: ${COLORS.background.main};
            border: 2px solid ${COLORS.text.accent} !important;
        } */

        /* span[class^="TypographyStyle"] {
            color: ${COLORS.text.main};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        } */
        /* &:hover {
            background: ${COLORS.text.accent};
            border: 2px solid ; 
            background: ${COLORS.text.accent};
            opacity: 0.3;
            background: none !important;

            span[class^="TypographyStyle"] {
                color: ${COLORS.text.main} ;
           
        }
        } */
        /* ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    padding: 5px 30px;
                `,
                null,
                null,
            ])} */
    `,

};
savedOrderDetailsActionButtonsStyles.addToListButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        border:1px solid ${COLORS.black} !important;
        ${mgbwOutlineButtonNoHover}
    `,

};
savedOrderDetailsActionButtonsStyles.placeOrderButton = {
    variant:"primary",
    css: css`
        margin-left: 10px;
        border:1px solid ${COLORS.black} !important;
        font-weight: ${TYPOGRAPHY.weight.bold};

        span[class^="TypographyStyle"] {
            font-weight: ${TYPOGRAPHY.weight.bold};
        }
        ${mgbwSolidButtonNoHover}
    `,
};
savedOrderDetailsActionButtonsStyles.twoButtonModalStyles = {
    messageText: {
        css: css`
            color: ${COLORS.text.main};
        `,
    },
    cancelButton: {
        css: css`
            border-radius: 0px;
            padding: 10px 34px;
            background: ${COLORS.background.main};
            border: 2px solid ${COLORS.primary.base} !important;

            span[class^="TypographyStyle"] {
                color: ${COLORS.text.main};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            &:hover {
                /* background: ${COLORS.text.accent}; */
                /* border: 2px solid  background: ${COLORS.text.accent}; */
                opacity: 0.3;
                background: none !important;

                /* span[class^="TypographyStyle"] {
                color: ${COLORS.secondary.base};
           
        } */
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 34px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    submitButton: {
        css: css`
            margin-left: 10px;
            border-radius: 0;
            padding: 10px 34px;
            background: ${COLORS.primary.base};
            border: 2px solid ${COLORS.primary.base};
            span[class^="TypographyStyle"] {
                color: ${COLORS.secondary.base};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            &:hover {
                background: ${COLORS.text.accent};
                border: 2px solid ${COLORS.text.accent};
                span[class^="TypographyStyle"] {
                    color: ${COLORS.secondary.base};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding: 10px 34px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
savedOrderDetailsActionButtonsStyles.menuHiddenContainer = {
    above: "sm",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                null,
                null,
            ])}
    `,
};
savedOrderDetailsActionButtonsStyles.middleOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            display: inline;
            margin-left: 20px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
